import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back_to_top_on_white",
  "use": "icon-back_to_top_on_white-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-back_to_top_on_white\">\n<path d=\"M26.0003 15.656V40H22.0003V15.656L11.2723 26.384L8.44434 23.556L24.0003 8L39.5563 23.556L36.7283 26.384L26.0003 15.656Z\" fill=\"#999999\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol